// extracted by mini-css-extract-plugin
module.exports = {"description":"info-module--description--2F-vx","info":"info-module--info--1JMut","trailer":"info-module--trailer--3zzLp"};